<template>
  <v-card
    color="blue"
    class="pt-1 pb-1 listItems"
    @click="showProd(product.code)"
  >
    <div class="image-div">
      <img
        v-if="getImg() !== ''"
        :src="getImg()"
        height="100%"
        width="100%"
        @load="redrawVueMasonry()"
      />
    </div>

    <div class="item-content">
      <h5 class="name">{{ product.name }}</h5>
      <div class="inline">
        <h5 class="from">Desde:</h5>
        <h4 class="price">$ {{ getMinPrice() }}</h4>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ProductItem",
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isReloadPageForRelatedProducts: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getImg() {
      return this.product.options[0].images[0].url;
    },
    getMinPrice() {
      let minPrice = 0;
      this.product.options.forEach((element) => {
        let price = parseInt(element.price);
        if (minPrice === 0 || minPrice > price) {
          minPrice = price;
        }
      });
      return minPrice;
    },
    showProd(code) {
      this.$router.replace(`Product?c=${code}`);

      if (this.isReloadPageForRelatedProducts) window.location.reload();
    },
    redrawVueMasonry() {
      this.$emit("redrawVueMasonry");
    },
  },
};
</script>


<style scoped>
.v-sheet.v-card:not(.v-sheet--outlined) {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.listItems {
  background-color: rgba(95, 106, 121, 0.06);
  -webkit-box-shadow: 0 2px 2px 0 rgba(50, 50, 50, 0.15) !important;
  box-shadow: 0 2px 2px 0 rgba(50, 50, 50, 0.15);
  margin: 8px;
  width: min-content;
  cursor: pointer;
}
.image-div {
  border-radius: 4px;
  border-right: 1px solid #f5f5f5;
  border-top: 1px solid #f5f5f5;
  margin-top: -5px;
}

.item-content {
  color: rgba(95, 106, 121, 0.8);
  padding: 0px 0px 1px 0px;
  text-align: center;
  width: 13vw;
}

.price {
  font-weight: 400;
  line-height: 1;
}

.name {
  min-height: -moz-fit-content;
  min-height: fit-content;
  height: -moz-min-content;
  margin: 3px 0 10px 0;
  font-size: 12px;
  line-height: 18px;
}
.inline {
  display: -webkit-inline-box;
  width: 100%;
  -webkit-box-pack: center;
}
.from {
  font-size: small;
  margin: 5px 8px 0px 0px;
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Open Sans";
  letter-spacing: 2px;
}
@media only screen and (max-width: 747px) {
  .item-content {
    width: 30vw;
  }
  .from {
    font-size: xx-small;
    margin: 1px 2px 0px 0px;
  }
  .price {
    font-size: 15px !important;
  }
  .name {
    margin: 3px 0 5px 0;
    font-size: 10px;
    line-height: 16px;
  }
}
@media only screen and (min-width: 1600px) {
  .item-content {
    width: 10vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductItem.vue